<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary pos-relative {{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
	>
		<div
			class="o-stack__cell portlet-subheader-wrapper"
			*ngIf="hasData && !isR1102 && !isR103 && !displayCreative.isTelevision"
		>
			<div class="r8-creatives-heading" style="display: none">{{ sectiontitle }} Creative Performance</div>
			<h5 *ngIf="!isR701 && !isR101">{{ isR104 && isEmail ? 'Email' : displayCreative?.creativeName }}</h5>
			<h5 *ngIf="isR701 || isR702">Creative</h5>
			<h5 *ngIf="isR101">Creatives</h5>
			<h5 class="dooh-overview-creatives" style="display: none" *ngIf="isR101">{{ displayCreative?.creativeName }}</h5>
			<h6
				class="portlet-subheader r8-portlet-subheader"
				style="font-size: 1.1em; display: none"
				*ngIf="totalCreatives > 0"
			>
				{{ count }} of {{ totalCreatives }} creatives
			</h6>
			<h6
				class="portlet-subheader r8-portlet-subheader r104-creatives"
				style="font-size: 1.1em"
				*ngIf="isR104 && totalCreatives > 0"
			>
				{{ count }} | {{ totalCreatives }}
			</h6>
			<h6 class="portlet-subheader" style="font-size: 1.1em" *ngIf="totalCreatives > 0">
				{{ count }} of {{ totalCreatives }} {{ sectiontitle }} creatives in selected date range
			</h6>
			<h6 class="portlet-subheader r101-style" style="font-size: 1.1em; display: none" *ngIf="totalCreatives > 0">
				{{ count }} | {{ totalCreatives }}
			</h6>
			<h6 class="portlet-subheader no-creative" *ngIf="totalCreatives == 0" style="font-size: 1.1em">
				No Data to Display
			</h6>
			<a
				href="#"
				class="datatable_download_icon"
				*ngIf="totalCreatives != 0 && downloadConfiguration && downloadConfiguration.enableDownload"
				(click)="downloadDataInCSV($event)"
				target="_blank"
			>
				<i class="fa fa-download" aria-hidden="true"></i>
			</a>
		</div>

		<div
			class="o-stack__cell portlet-subheader-wrapper"
			*ngIf="hasData && !isR1102 && isR103 && !displayCreative.isTelevision"
		>
			<h5 *ngIf="!isSocial && !isDisplay && !isDOOH">Creative</h5>
			<h5 *ngIf="isSocial || isDisplay || isDOOH">{{ displayCreative?.creativeName }}</h5>
			<h6 class="portlet-subheader" style="font-size: 1.1em" *ngIf="totalCreatives > 0">
				{{ count }} of {{ totalCreatives }} {{ sectiontitle }} creatives in selected date range
			</h6>
			<a
				href="#"
				class="datatable_download_icon"
				*ngIf="totalCreatives != 0 && downloadConfiguration && downloadConfiguration.enableDownload"
				(click)="downloadDataInCSV($event)"
				target="_blank"
			>
				<i class="fa fa-download" aria-hidden="true"></i>
			</a>
		</div>

		<div
			class="o-stack__cell portlet-subheader-wrapper"
			*ngIf="hasData && isR1102 && !isR103 && !isR6 && !displayCreative.isTelevision"
		>
			<h5>
				Creatives: {{ displayCreative?.creativeName }}
				<span>
					<a
						href="#"
						class="datatable_download_icon"
						*ngIf="totalCreatives != 0 && downloadConfiguration && downloadConfiguration.enableDownload"
						(click)="downloadDataInCSV($event)"
						target="_blank"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</h5>
		</div>

		<div class="o-stack__cell portlet-subheader-wrapper" *ngIf="hasData && isR6 && !displayCreative.isTelevision">
			<h5>
				{{ displayCreative?.creativeName }}
				<span>
					<a
						href="#"
						class="datatable_download_icon"
						*ngIf="totalCreatives != 0 && downloadConfiguration && downloadConfiguration.enableDownload"
						(click)="downloadDataInCSV($event)"
						target="_blank"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</h5>
		</div>

		<div
			class="o-stack__cell portlet-subheader-wrapper"
			*ngIf="hasData && displayCreative.isTelevision && (partnerName === 'Midco' || allowTelevisionCreative)"
			style="text-align: left; position: relative"
		>
			<h5>Creatives: {{ displayCreative?.creativeName }}</h5>
			<h6 class="portlet-subheader r1_header" style="font-size: 1.1em" *ngIf="totalCreatives > 0">
				{{ count }} of {{ totalCreatives }} Television creatives in selected date range
			</h6>
			<h6 class="portlet-subheader r101_header" style="font-size: 1.1em; display: none" *ngIf="totalCreatives > 0">
				{{ count }} | {{ totalCreatives }}
			</h6>
			<h6 class="portlet-subheader" *ngIf="totalCreatives == 0" style="font-size: 1.1em">No Data to Display</h6>
			<a
				href="#"
				class="datatable_download_icon"
				[ngClass]="displayCreative?.creativeName ? 'download_icon_withdata' : 'download_icon_nodata'"
				*ngIf="totalCreatives != 0 && downloadConfiguration && downloadConfiguration.enableDownload"
				(click)="downloadDataInCSV($event)"
				target="_blank"
			>
				<i *ngIf="!downloadIcon" class="fa fa-download" aria-hidden="true"></i>
				<img *ngIf="downloadIcon" class="downloadIcon" src="{{ downloadIcon }}" />
			</a>
		</div>
		<div
			class="o-stack__cell portlet-subheader-wrapper"
			*ngIf="!hasData"
			[ngClass]="isTelevisionCreative ? 'text_left_alignment' : ''"
		>
			<div class="r8-creatives-heading" style="display: none">{{ sectiontitle }} Creative Performance</div>
			<div class="dooh-no-data-creatives" style="display: none" *ngIf="isR101">DOOH Display Creatives</div>
			<h5 class="no-data-creatives" *ngIf="!isR9 && !isR8">{{ isR104 && isEmail ? 'Email' : 'Creatives' }}</h5>
			<h5 *ngIf="isR702">Creative</h5>
			<h5 *ngIf="isR9" class="no-data-title">Creatives</h5>
			<h6 class="portlet-subheader no-data-portlet-subheader" *ngIf="totalCreatives == 0" style="font-size: 1.1em">
				No Data to Display
			</h6>
		</div>
	</div>
	<div
		class="c-portlet__content u-pt-small"
		style="width: 100%; position: relative"
		[ngClass]="{ 'no-data': !hasData }"
	>
		<div
			class="o-stack__cell"
			style="position: absolute; width: 100%; height: 100%"
			*ngIf="totalCreatives > 1 && hasData"
		>
			<div class="o-stack o-stack--center o-stack--nowrap" style="width: 100%; height: 100%; position: relative">
				<div class="o-stack__cell u-relative" style="width: 100%; height: 100%">
					<a
						class="u-opacity-50p leftRs"
						[ngClass]="
							displayCreative.isTelevision && (partnerName === 'Midco' || allowTelevisionCreative) ? 'left_20' : ''
						"
					>
						<span class="next" (click)="nextArrow()" class="carousel-arrow-style">
							<i *ngIf="!isR103" style="font-size: 5rem" class="fa fa-angle-left" aria-hidden="true"></i>
							<i *ngIf="isR103">
								<svg width="36" height="31" viewBox="0 0 36 31" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g id="chevron-up-solid 4" clip-path="url(#clip0_4896_525)">
										<path
											id="Vector"
											d="M7.41089 13.9362C6.53198 14.8011 6.53198 16.2058 7.41089 17.0708L20.9109 30.3565C21.7898 31.2214 23.2171 31.2214 24.096 30.3565C24.975 29.4915 24.975 28.0868 24.096 27.2219L12.1851 15.5L24.089 3.77813C24.9679 2.91317 24.9679 1.50848 24.089 0.643529C23.2101 -0.221427 21.7828 -0.221427 20.9039 0.643529L7.40386 13.9292L7.41089 13.9362Z"
											fill="white"
										/>
									</g>
									<defs>
										<clipPath id="clip0_4896_525">
											<rect width="31" height="36" fill="white" transform="matrix(0 1 1 0 0 0)" />
										</clipPath>
									</defs>
								</svg>
							</i> </span
					></a>
					<a
						class="u-opacity-50p rightRs"
						[ngClass]="
							displayCreative.isTelevision && (partnerName === 'Midco' || allowTelevisionCreative) ? 'right_20' : ''
						"
					>
						<span class="prev" (click)="prevArrow()" class="carousel-arrow-style">
							<i *ngIf="!isR103" style="font-size: 5rem" class="fa fa-angle-right" aria-hidden="true"></i>
							<i *ngIf="isR103">
								<svg width="36" height="31" viewBox="0 0 36 31" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g id="chevron-up-solid 5" clip-path="url(#clip0_4896_523)">
										<path
											id="Vector"
											d="M28.5891 17.0638C29.468 16.1989 29.468 14.7942 28.5891 13.9292L15.0891 0.643522C14.2102 -0.221434 12.7829 -0.221434 11.904 0.643522C11.025 1.50848 11.025 2.91317 11.904 3.77812L23.8149 15.5L11.911 27.2219C11.0321 28.0868 11.0321 29.4915 11.911 30.3565C12.7899 31.2214 14.2172 31.2214 15.0961 30.3565L28.5961 17.0708L28.5891 17.0638Z"
											fill="white"
										/>
									</g>
									<defs>
										<clipPath id="clip0_4896_523">
											<rect
												width="31"
												height="36"
												fill="white"
												transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 36 31)"
											/>
										</clipPath>
									</defs>
								</svg>
							</i>
						</span>
					</a>
					<div class="display-carousel-table-container engagements-grid" *ngIf="displayCreative.isSocial">
						<ul class="creative-stats">
							<li>
								<span class="stats">{{ displayCreative?.engagements | number }}</span>
								<span class="stats-label">Engagements</span>
							</li>
							<li>
								<span class="stats">{{ displayCreative?.likes | number }}</span>
								<span class="stats-label">Likes</span>
							</li>
							<li>
								<span class="stats">{{ displayCreative?.comments | number }}</span>
								<span class="stats-label">Comments</span>
							</li>
							<li>
								<span class="stats">{{ displayCreative?.shares | number }}</span>
								<span class="stats-label">Shares</span>
							</li>
							<li>
								<span class="stats">{{ displayCreative?.saves | number }}</span>
								<span class="stats-label">Saves</span>
							</li>
							<li>
								<span class="stats">{{ displayCreative?.reactions | number }}</span>
								<span class="stats-label">Reactions</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div
			class="analytics-portlet-content"
			style="width: 100%; height: 512px"
			*ngIf="hasData && !displayCreative.isTelevision"
		>
			<div *ngIf="displayCreative" class="r4-email-creative">
				<div class="email-creative-details" *ngIf="displayCreative.isEmail && !isR1102">
					<h5 *ngIf="isR4 && isEmail" class="email-creative-heading">Email Creative</h5>
					<h5 class="email-creative-name">{{ displayCreative?.creativeName }}</h5>
					<div class="email-from-line">From/Brand: {{ displayCreative?.fromLine }}</div>
					<div class="email-deployment-date">
						<span>Deployment date: </span><span>{{ displayCreative?.date }}</span>
					</div>
				</div>
				<div class="email-creative-details" *ngIf="displayCreative.isEmail && isR1102">
					<div class="email-from-line">From/Brand: {{ displayCreative?.fromLine }}</div>
					<div class="email-deployment-date">
						<span>Deployment date: </span><span>{{ displayCreative?.date }}</span>
					</div>
				</div>
				<div class="display-carousel-table-container" *ngIf="!displayCreative.isTelevision && !displayCreative.isEmail">
					<ul class="creative-stats" *ngIf="!isR8">
						<li>
							<span class="stats">{{ displayCreative?.impressions | number }}</span>
							<span class="stats-label">Impressions</span>
						</li>
						<li *ngIf="displayCreative?.adInteractions !== null && displayCreative?.isIAB && !isGam">
							<span class="stats">{{ displayCreative?.adInteractions | number }}</span>
							<span class="stats-label">Ad Interactions</span>
						</li>
						<li *ngIf="displayCreative?.adInteractionRate !== null && displayCreative?.isIAB && !isGam">
							<span class="stats">{{ displayCreative?.adInteractionRate | number }}%</span>
							<span class="stats-label">Ad Interaction Rate</span>
						</li>
						<li>
							<span class="stats">{{ displayCreative?.clicks | number }}</span>
							<span class="stats-label">Clicks</span>
						</li>
						<li>
							<span class="stats">{{ displayCreative?.clickRate | number }}%</span>
							<span class="stats-label">Click Rate</span>
						</li>
						<li *ngIf="displayCreative?.isSocial && displayCreative?.percentRate25 > 0">
							<span class="stats">{{ displayCreative?.percentRate100 | number : '1.2-2' }}%</span>
							<span class="stats-label">Completion Rate</span>
						</li>
					</ul>
					<ul class="creative-stats" *ngIf="isR8 && !isDisplay && !isGam">
						<li>
							<span class="stats">{{ displayCreative?.impressions | number }}</span>
							<span class="stats-label">Impressions</span>
						</li>
						<li *ngIf="displayCreative?.adInteractions !== null && displayCreative?.isIAB && !isGam">
							<span class="stats">{{ displayCreative?.adInteractions | number }}</span>
							<span class="stats-label">Ad Interactions</span>
						</li>
						<li *ngIf="displayCreative?.adInteractionRate !== null && displayCreative?.isIAB && !isGam">
							<span class="stats">{{ displayCreative?.adInteractionRate | number }}%</span>
							<span class="stats-label">Ad Interaction Rate</span>
						</li>
						<li>
							<span class="stats">{{ displayCreative?.clicks | number }}</span>
							<span class="stats-label">Clicks</span>
						</li>
						<li>
							<span class="stats">{{ displayCreative?.clickRate | number }}%</span>
							<span class="stats-label">Click Rate</span>
						</li>
						<li *ngIf="displayCreative?.isSocial && displayCreative?.percentRate25 > 0">
							<span class="stats">{{ displayCreative?.percentRate100 | number : '1.2-2' }}%</span>
							<span class="stats-label">Completion Rate</span>
						</li>
					</ul>
					<ul class="creative-stats" *ngIf="isR8 && (isDisplay || isGam)">
						<div class="metrics-one">
							<li>
								<span class="stats">{{ displayCreative?.impressions | number }}</span>
								<span class="stats-label">Impressions</span>
							</li>
							<li>
								<span class="stats">{{ displayCreative?.clicks | number }}</span>
								<span class="stats-label">Clicks</span>
							</li>
							<li>
								<span class="stats">{{ displayCreative?.clickRate | number }}%</span>
								<span class="stats-label">Click Rate</span>
							</li>
							<li *ngIf="displayCreative?.isSocial && displayCreative?.percentRate25 > 0">
								<span class="stats">{{ displayCreative?.percentRate100 | number : '1.2-2' }}%</span>
								<span class="stats-label">Completion Rate</span>
							</li>
						</div>
						<div class="metrics-two">
							<li *ngIf="displayCreative?.adInteractions !== null && displayCreative?.isIAB && !isGam">
								<span class="stats">{{ displayCreative?.adInteractions | number }}</span>
								<span class="stats-label">Ad Interactions</span>
							</li>
							<li *ngIf="displayCreative?.adInteractionRate !== null && displayCreative?.isIAB && !isGam">
								<span class="stats">{{ displayCreative?.adInteractionRate | number }}%</span>
								<span class="stats-label">Ad Interaction Rate</span>
							</li>
						</div>
					</ul>
				</div>
				<div class="display-carousel-table-container" *ngIf="displayCreative.isEmail && !isR1102 && !isR3">
					<ul class="creative-stats">
						<li>
							<span class="stats">{{ displayCreative?.audience | number }}</span>
							<span class="stats-label">Sends</span>
						</li>
						<li>
							<span class="stats">{{ displayCreative?.opens | number }}</span>
							<span class="stats-label">Opens</span>
						</li>
						<li>
							<span class="stats">{{ displayCreative?.openRate | number }}%</span>
							<span class="stats-label">Open Rate</span>
						</li>
						<li>
							<span class="stats">{{ displayCreative?.clicks | number }}</span>
							<span class="stats-label">Clicks</span>
						</li>
						<li>
							<span class="stats">{{ displayCreative?.clickRate | number }}%</span>
							<span class="stats-label">Click Rate</span>
						</li>
					</ul>
				</div>
				<div class="display-carousel-table-container" *ngIf="displayCreative.isEmail && !isR1102 && isR3">
					<ul class="creative-stats">
						<li>
							<span appTooltip title="Number of emails sent" [options]="tooltipR3Options">
								<span class="stats">{{ displayCreative?.audience | number }}</span>
								<span class="stats-label">Sends</span>
							</span>
						</li>
						<li>
							<span
								appTooltip
								title="Number of emails opened <br/><br/> Open Rate = Opens/Sends <br/><span style='display: flex; text-align: left; margin-top: 10px;'>Please note: Opens are attributed to the campaign’s deployment date for reporting purposes.</span>"
								[options]="tooltipR3Options"
							>
								<span class="stats">{{ displayCreative?.opens | number }}</span>
								<span class="stats-label">Opens</span>
							</span>
						</li>
						<li>
							<span>
								<span class="stats">{{ displayCreative?.openRate | number }}%</span>
								<span class="stats-label">Open Rate</span>
							</span>
						</li>
						<li>
							<span
								appTooltip
								title="Number of clicks within an email <br/><br/> Click Rate = Clicks/Sends <br/><span style='display: flex; text-align: left; margin-top: 10px;'>Please note: Clicks are attributed to the campaign’s deployment date for reporting purposes.</span>"
								[options]="tooltipR3Options"
							>
								<span class="stats">{{ displayCreative?.clicks | number }}</span>
								<span class="stats-label">Clicks</span>
							</span>
						</li>
						<li>
							<span>
								<span class="stats">{{ displayCreative?.clickRate | number }}%</span>
								<span class="stats-label">Click Rate</span>
							</span>
						</li>
					</ul>
				</div>
				<div class="display-carousel-table-container" *ngIf="displayCreative.isEmail && isR1102">
					<ul class="creative-stats" *ngIf="!isR6">
						<li>
							<span class="stats-label">Sends</span>
							<span class="stats">{{ displayCreative?.audience | number }}</span>
						</li>
						<li>
							<span class="stats-label">Opens</span>
							<span class="stats">{{ displayCreative?.opens | number }}</span>
						</li>
						<li>
							<span class="stats-label">Open Rate</span>
							<span class="stats">{{ displayCreative?.openRate | number : '1.2-2' }}%</span>
						</li>
						<li>
							<span class="stats-label">Clicks</span>
							<span class="stats">{{ displayCreative?.clicks | number }}</span>
						</li>
						<li>
							<span class="stats-label">Click Rate</span>
							<span class="stats">{{ displayCreative?.clickRate | number : '1.2-2' }}%</span>
						</li>
					</ul>
					<ul class="creative-stats" *ngIf="isR6">
						<li>
							<span class="stats-label">Sends</span>
							<span class="stats">{{ displayCreative?.audience | number }}</span>
						</li>
						<li>
							<span class="stats-label">Opens</span>
							<span class="stats"
								>{{ displayCreative?.opens | number }} | {{ displayCreative?.openRate | number : '1.2-2' }}%</span
							>
						</li>
						<li>
							<span class="stats-label">Clicks</span>
							<span class="stats"
								>{{ displayCreative?.clicks | number }} | {{ displayCreative?.clickRate | number : '1.2-2' }}%</span
							>
						</li>
					</ul>
				</div>
				<div
					style="height: 380px"
					class="creative-image-section {{ sectionclass }}"
					*ngIf="!displayCreative.isTelevision"
				>
					<div class="display_creative_img">
						<img
							[src]="displayCreative?.creativeThumbnail"
							*ngIf="displayCreative?.creativeThumbnail && !displayCreative.isSocial && !displayCreative.isEmail"
							class="card-long-img"
							(click)="openModal('display-creative-v1_' + key, displayCreative)"
							[ngClass]="{
								c300x600: displayCreative?.creativeThumbnail?.includes('300x600'),
								c728x90: displayCreative?.creativeThumbnail?.includes('728x90'),
								c160x600: displayCreative?.creativeThumbnail?.includes('160x600'),
								c320x50:
									displayCreative?.creativeThumbnail?.includes('320x50') ||
									displayCreative?.creativeThumbnail?.includes('300x50'),
								c468x60: displayCreative?.creativeThumbnail?.includes('468x60'),
								c300x250: displayCreative?.creativeThumbnail?.includes('300x250')
							}"
						/>
						<img
							[src]="displayCreative?.creativeThumbnail"
							*ngIf="displayCreative?.creativeThumbnail && displayCreative.isEmail"
							class="card-long-img"
							[ngClass]="{
								c300x600: displayCreative?.creativeThumbnail?.includes('300x600'),
								c728x90: displayCreative?.creativeThumbnail?.includes('728x90'),
								c160x600: displayCreative?.creativeThumbnail?.includes('160x600'),
								c320x50:
									displayCreative?.creativeThumbnail?.includes('320x50') ||
									displayCreative?.creativeThumbnail?.includes('300x50'),
								c468x60: displayCreative?.creativeThumbnail?.includes('468x60'),
								c300x250: displayCreative?.creativeThumbnail?.includes('300x250')
							}"
						/>
						<img
							[src]="displayCreative?.creativeThumbnail"
							*ngIf="displayCreative?.creativeThumbnail && displayCreative.isSocial"
							class="card-long-img"
							(click)="openModal('display-creative-v1', displayCreative)"
							[ngClass]="{
								c300x600: displayCreative?.creativeThumbnail?.includes('300x600'),
								c728x90: displayCreative?.creativeThumbnail?.includes('728x90'),
								c160x600: displayCreative?.creativeThumbnail?.includes('160x600'),
								c320x50:
									displayCreative?.creativeThumbnail?.includes('320x50') ||
									displayCreative?.creativeThumbnail?.includes('300x50'),
								c468x60: displayCreative?.creativeThumbnail?.includes('468x60'),
								c300x250: displayCreative?.creativeThumbnail?.includes('300x250')
							}"
						/>
						<img
							[src]="displayCreative?.snapshotImage"
							*ngIf="
								displayCreative?.snapshotImage &&
								displayCreative?.snapshotImage !== 'null' &&
								displayCreative.isSocial &&
								!displayCreative.creativeThumbnail &&
								displayCreative.isIframeExpired === 1
							"
							class="card-long-img"
							(click)="openModal('display-creative-v1', displayCreative)"
							[ngClass]="{
								c300x600: displayCreative?.creativeThumbnail?.includes('300x600'),
								c728x90: displayCreative?.creativeThumbnail?.includes('728x90'),
								c160x600: displayCreative?.creativeThumbnail?.includes('160x600'),
								c320x50:
									displayCreative?.creativeThumbnail?.includes('320x50') ||
									displayCreative?.creativeThumbnail?.includes('300x50'),
								c468x60: displayCreative?.creativeThumbnail?.includes('468x60'),
								c300x250: displayCreative?.creativeThumbnail?.includes('300x250')
							}"
						/>
						<div
							*ngIf="
								(!displayCreative?.snapshotImage || displayCreative?.snapshotImage === 'null') &&
								!displayCreative.creativeThumbnail &&
								displayCreative.isSocial
							"
							class="card-long-img"
						>
							<div
								class="card-long-img"
								[ngStyle]="{
									background: 'url(../../../../../../assets/images/no-creative-preview-r2.png) no-repeat center center',
									'background-size': getCreativeSize(displayCreative?.creativeThumbnail)
								}"
							></div>
							<div style="clear: both"></div>
						</div>
						<div
							[ngClass]="{
								'badge-display': !displayCreative?.noPreviewImage,
								'no-preview-badge-display': displayCreative?.noPreviewImage,
								display_bade_left1:
									displayCreative?.creativeThumbnail?.includes('300x600') ||
									displayCreative?.creativeThumbnail?.includes('300x50'),
								display_bade_left2: displayCreative?.creativeThumbnail?.includes('160x600')
							}"
						>
							<p class="pills" *ngIf="displayCreative?.isIAB">IAB Display</p>
							<p class="pills" *ngIf="displayCreative?.isNative">Native</p>
						</div>
					</div>
					<div
						class="email-creative-preview-link"
						*ngIf="isEmail && !isR701 && !isR702"
						(click)="getPreviewScreenshot(displayCreative?.creativeThumbnail && displayCreative?.creativeThumbnail)"
					>
						{{ isR104 ? 'View Full Screen Preview' : 'Click to view full screen preview' }}
					</div>
				</div>
				<div
					class="email-creative-preview-link"
					*ngIf="isEmail && (isR701 || isR702)"
					(click)="getPreviewScreenshot(displayCreative?.creativeThumbnail && displayCreative?.creativeThumbnail)"
				>
					Click to view full screen preview
				</div>
				<div class="top-links-details" *ngIf="isEmail && topLinksData.length > 0">
					<app-datatable
						[sectiontitle]="sectiontitle"
						[datatableconfig]="datatableconfig"
						[isemail]="isEmail"
						[toplinks]="topLinksData"
						[isClickable]="true"
						[isVerticalScrollable]="false"
						[rowHeight]="40"
					></app-datatable>
				</div>
			</div>
			<ul
				class="carousel-points-container-r5 myPoint"
				*ngIf="displayCreative.isEmail && (isR1102 || isR9 || isR5 || isR7)"
			>
				<li [ngClass]="{ 'highlight-light': i === displayIndex }" *ngFor="let j of creatives; let i = index"></li>
			</ul>
		</div>
		<div
			class="analytics-portlet-content"
			style="width: 100%; height: auto"
			*ngIf="displayCreative.isTelevision && (partnerName === 'Midco' || allowTelevisionCreative) && hasData"
		>
			<div *ngIf="displayCreative" class="flex-container">
				<div class="top-five-networks">
					<div class="top_networks">Top Networks</div>
					<div class="top5_network_logos" *ngIf="displayCreative.networkData?.length > 0">
						<div class="network_logo_container" *ngFor="let network of displayCreative.networkData">
							<img *ngIf="network.logo !== ''" class="network_logo" [src]="network.logo" />
							<div class="network-logo-div" *ngIf="network.logo === ''">
								<span class="network-logo-name">
									<span
										class="network-logo-name-margin"
										id="tvNetworkLogo"
										style="font-size: 25px; font-weight: bold"
										>{{ network.marphedlogo }}</span
									>
								</span>
							</div>
							<div class="network_name">{{ network.name }}</div>
						</div>
					</div>
				</div>
				<div *ngIf="!(displayCreative.networkData?.length > 0)" class="no_network_data">No Network Data Available</div>
				<div class="tv_video_conatainer">
					<div class="television-creative-name" *ngIf="isR103 && displayCreative.isTelevision && totalCreatives > 0">
						{{ count }} of {{ totalCreatives }} TV creatives in selected date range
					</div>
					<div class="video_placeholder">
						<div *ngIf="displayCreative.isVideoCreative" class="creative-video">
							<app-video-player [videoURL]="displayCreative.creativeVideo"></app-video-player>
						</div>
						<div *ngIf="!displayCreative.isVideoCreative" class="no_video_creative">
							<app-video-player [videoURL]="" style="visibility: hidden; position: absolute"></app-video-player>
							<span style="margin: auto; color: #607d8b"> Video Unavailable </span>
						</div>
					</div>
					<ul class="tv_creative-stats creative-stats">
						<li>
							<span class="stats">{{ displayCreative?.exposures | number }}</span>
							<span class="stats-label">Exposures</span>
						</li>
						<li>
							<span class="stats">{{ displayCreative?.zones | number }}</span>
							<span class="stats-label">Zones</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="no-creative-data-div" *ngIf="!hasData && !isTelevisionCreative">
			<img src="/assets/images/no-creative-performance-data-display.png" class="no-creative-data" width="100%" />
		</div>
		<div *ngIf="!hasData && isTelevisionCreative && (partnerName === 'Midco' || allowTelevisionCreative)">
			<img
				src="/assets/images/no-creative-performance-data-television.png"
				class="no-creative-data"
				[ngClass]="isTelevisionCreative ? 'no-creative-tv-data' : ''"
				width="100%"
			/>
		</div>
	</div>
</div>
<app-modal id="display-creative-v1_{{ key }}">
	<app-creative-ad-preview
		[creative]="selectedCreative"
		(modalClose)="closeModal('display-creative-v1_' + key)"
		[producttype]="producttype"
	></app-creative-ad-preview>
	<div class="modal-background"></div>
</app-modal>
